import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { DialogService } from '../../../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StationService } from '../../../_services/fundraising/station.service';
import { StationApp } from '../../../_models/fundraising/PosStation';
import { StationAppUploadModalComponent } from './station-app-upload-modal.component';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-station-app-management',
  templateUrl: './station-app-management.component.html',
  styleUrls: ['./station-app-management.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class StationAppManagementComponent implements OnInit {

  stationApps: StationApp[] = [];

  private bsModalRef: BsModalRef;

  copied = {};

  constructor(
    private stationService: StationService,
    private dialogService: DialogService,
    public viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private clipboardService: ClipboardService
  ) { }

  ngOnInit(): void {
    this.getStationApps();
  }

  public createNew() {
    this.openAppUploadModal();
  }

  public openAppUploadModal() {
    const modalConfig = {
        backdrop: true,
        ignoreBackdropClick: true
    };

    const initialState = {
      currentVersion: this.stationApps[0]?.version ?? '0.0.0'
    };

    this.bsModalRef = this.modalService
      .show(
        StationAppUploadModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-md', initialState })
      );

    this.bsModalRef.content.hasError.subscribe(
        value => {
            if (value) {
              this.dialogService.alert('Error', `Unable to create new station app`, this.viewRef);
            } else {
              this.getStationApps();
            }
      });
  }

  copy(url: string, rowIndex: number) {
    this.copied = {};
    this.copied[rowIndex + '-fileUrl'] = true;
    this.clipboardService.copyFromContent(url);
  }

  confirmForceUpdate(id: number) {
    this.dialogService.confirm(
      'Force Update',
      'Are you sure you want to force this update?',
      this.viewRef)
        .then((result) => {
          if (result === true) {

            this.spinner.show();

            this.stationService.forceUpdate(id)
              .subscribe(
                ()=> this.getStationApps(),
                error => {
                  this.dialogService.alert(
                    'Uh oh something isn\'t right here...',
                    `Unable to update station app. ${error.error}`,
                    this.viewRef);

                    this.spinner.hide();
                });     
          }
        });
  }

  confirmSetCurrent(id: number) {
    this.dialogService.confirm(
      'Set Current',
      'Are you sure you want to set this as the current version?',
      this.viewRef)
        .then((result) => {
          if (result === true) {

            this.spinner.show();

            this.stationService.setCurrent(id)
              .subscribe(
                ()=> this.getStationApps(),
                error => {
                  this.dialogService.alert(
                    'Uh oh something isn\'t right here...',
                    `Unable to update station app. ${error.error}`,
                    this.viewRef);

                    this.spinner.hide();
                });     
          }
        });
  }

  public getStationApps() {
    this.spinner.show();
    this.stationService.getStationApps().subscribe(
      data => {
        this.stationApps = data;
      },
      error => {
        this.dialogService.alert('Error', `Unable to get station apps. ${error.error}`, this.viewRef);
      },
      () => {
        this.spinner.hide();
      }
    );
  }

}
